let authorization = {
  title: "Application permission delegation",
  columns: {
    appName: "Delegated application name",
    action: "Action",
    consigneeName: "Consignee",
    actionType: "Operation",
    device: "Entrustment time",
    perm:'Whether have the right',
    startTime: 'Delegation start time',
    endTime: 'Delegation end time',
  },
  draw:{

  },
  noAccess:'No access',
  beoverdue:'Be overdue',
  add:'Add Delegate',
  delecteall:'Batch Cancel',
  warn:'Please select the delegation you want to cancel',
  edit:'edit',
  cancel:'cancel',
  type: "Operation type",
  result: "Operation result",
  time: "Operation time",
  startTime:"Delegation start time",
  endTime:"Delegation end time",
  dialogTitle:'Are you sure you want to cancel the delegation?',
  appName: "Delegated application name",
  consigneeName: "Consignee",
  details: "Details of Operation Records",
  tip:{
    appName:'Please select a delegated application',
    consigneeName:'Please select the consignee',
    startTime:'Please select the delegation start time',
    endTime:'Please select the delegation end time',
    timeValid:'The end time of the delegation should be greater than the start time of the delegation',
    searchName:'Enter the full user name and press <kbd>Enter</kbd> to search',
    searchEnterNoFind:"Can't find{0}",
    user:'user'
  },
  selectType: {
    type01: 'All',
    type02: 'login',
    type03: 'Logout',
    type04: 'bind',
    type05: 'modify',
    type06: 'reset',
    type07: 'unbind',
    type08: 'activate',
    type09: 'visit',
    type10: 'send',
  },
  resultType: {
    label01: "All",
    label02: "Fail",
    label03: "Success",
  },
  entrustmentRecord:'Entrustment record',
  entrustmentRecordDetail: {
    consigneeAppName:"Delegated application name",
    consigneeName:"Consignee",
    startTime:"Delegation start time",
    endTime:"Entrustment end time",
    createTime:"Operation time",
    status:"Current state"
  },
  status: {
    0: "Canceled",
    1: "In force",
    2: "Expired",
    3: "Deprecated",
  },
}

export default authorization
